import React, { useState, useEffect } from "react";
import "./style.css";
import Table from "react-bootstrap/Table";
import API from "../../utils/API";

function randomHex(bytes) {
  const array = new Uint8Array(bytes);
  window.crypto.getRandomValues(array);
  return Array.from(array, (b) => b.toString(16).padStart(2, "0")).join("");
}

function ConvertClient({ sourceData, agents }) {
  const [formData, setFormData] = useState({
    clientFirstName: "",
    clientLastName: "",
    clientEmail: "",
    clientTelephone: "",
    clientAddress: "",
    agent1: "",
    agent2: "",
    agent3: "",
    agent4: ""
  });

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      clientFirstName: sourceData.firstName,
      clientLastName: sourceData.lastName,
      clientEmail: sourceData.email,
      clientTelephone: sourceData.phone,
      clientAddress: sourceData.quickAddress
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const submitClient = (e) => {
    e.preventDefault();
    API.convertClient(sourceData._id, {
      uid: randomHex(20),
      firstName: formData.clientFirstName,
      lastName: formData.clientLastName,
      email: formData.clientEmail,
      telephone: formData.clientTelephone,
      address: formData.clientAddress,
      servicer: "Fawn Circle",
      agent1: formData.agent1,
      agent2: formData.agent2,
      agent3: formData.agent3,
      agent4: formData.agent4
    })
      .then((_dbClient) => {
        alert("Quote converted to Client Success!");
      })
      .catch((error) => {
        console.log(error);
        alert("Error: Client not created!");
      });
  };

  return (
    <div
      className="card"
      style={{ borderRadius: "10px", color: "black", overflow: "auto", padding: "0" }}
    >
      <div className="card-header">
        <h5 style={{ textAlign: "center" }}>Convert a Client</h5>
      </div>
      <div className="card-body" style={{ backgroundColor: "transparent" }}>
        <form>
          <Table
            bordered
            hover
            style={{ backgroundColor: "white", height: "100%", width: "600px" }}
          >
            <tbody>
              <tr>
                <td style={{ width: "200px" }}>
                  <strong>Question</strong>
                </td>
                <td style={{ width: "400px" }}>
                  <strong>Input</strong>
                </td>
              </tr>
              <tr>
                <td>First Name</td>
                <td>
                  <input
                    type="text"
                    value={formData.clientFirstName}
                    onChange={handleInputChange}
                    name="clientFirstName"
                  />
                </td>
              </tr>
              <tr>
                <td>Last Name</td>
                <td>
                  <input
                    type="text"
                    value={formData.clientLastName}
                    onChange={handleInputChange}
                    name="clientLastName"
                  />
                </td>
              </tr>
              <tr>
                <td>Email</td>
                <td>
                  {" "}
                  <input
                    type="text"
                    value={formData.clientEmail}
                    onChange={handleInputChange}
                    name="clientEmail"
                  />
                </td>
              </tr>
              <tr>
                <td>Telephone</td>
                <td>
                  <input
                    type="text"
                    value={formData.clientTelephone}
                    onChange={handleInputChange}
                    name="clientTelephone"
                  />
                </td>
              </tr>
              <tr>
                <td>Address</td>
                <td>
                  <input
                    type="text"
                    value={formData.clientAddress}
                    onChange={handleInputChange}
                    name="clientAddress"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <strong>P+C Agent</strong>
                  </label>
                </td>
                <td>
                  {agents ? (
                    <div>
                      <select
                        id="protegeDropMenu"
                        value={formData.agent1}
                        onChange={handleInputChange}
                        name="agent1"
                      >
                        <option value="">--Select an Agent--</option>
                        {agents.map((agent) => (
                          <option key={agent._id} value={agent._id}>
                            {agent.firstName} {agent.lastName}
                          </option>
                        ))}
                      </select>
                    </div>
                  ) : (
                    <div>No agents yet</div>
                  )}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <strong>Agent 2</strong>
                  </label>
                </td>
                <td>
                  {agents ? (
                    <div>
                      <select
                        id="protegeDropMenu"
                        value={formData.agent2}
                        onChange={handleInputChange}
                        name="agent2"
                      >
                        <option value="">--Select an Agent--</option>
                        {agents.map((agent) => (
                          <option key={agent._id} value={agent._id}>
                            {agent.firstName} {agent.lastName}
                          </option>
                        ))}
                      </select>
                    </div>
                  ) : (
                    <div>No agents yet</div>
                  )}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <strong>Agent 3</strong>
                  </label>
                </td>
                <td>
                  {agents ? (
                    <div>
                      <select
                        id="protegeDropMenu"
                        value={formData.agent3}
                        onChange={handleInputChange}
                        name="agent3"
                      >
                        <option value="">--Select an Agent--</option>
                        {agents.map((agent) => (
                          <option key={agent._id} value={agent._id}>
                            {agent.firstName} {agent.lastName}
                          </option>
                        ))}
                      </select>
                    </div>
                  ) : (
                    <div>No agents yet</div>
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
          <div style={{ textAlign: "center" }}>
            <button
              style={{
                color: "white",
                fontSize: "20px",
                boxShadow: "0px 0px 1px 1px black",
                backgroundImage: "linear-gradient(147deg, black 74%, white 0%)",
                padding: "5px 20px 5px 20px",
                borderRadius: "5px"
              }}
              onClick={submitClient}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ConvertClient;
